import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import clsx from 'clsx';
import { List, ListItem, ListItemIcon, ListItemText, SwipeableDrawer, Typography, type Theme } from '@mui/material';
import { RoutePaths } from '@shared/utils';
import { RouterNavLink } from '@shared/widgets';
import { useStyles } from './styles';

interface Props {
  open: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const Sidebar = (props: Props) => {
  const theme = useTheme<Theme>();
  const classes = useStyles();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));

  const routes = useMemo(() => RoutePaths.getRoutes(), []);

  const location = useLocation();

  useEffect(() => {
    if (isLg && props.open) props.closeDrawer();
  }, [isLg, props.open, props.closeDrawer]);

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <SwipeableDrawer
      anchor='left'
      ModalProps={{ keepMounted: true }}
      variant={isLg ? 'permanent' : 'temporary'}
      open={isLg || props.open}
      onClose={props.closeDrawer}
      onOpen={props.openDrawer}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      classes={{ paper: classes.drawer }}
    >
      <List dense className={classes.list}>
        {routes.map(({ path, icon: Icon, title }) => (
          <ListItem
            key={path}
            className={clsx(classes.item, location.pathname.includes(`/${path}`) && classes.itemActive)}
            component={RouterNavLink}
            to={path}
            button
            onClick={props.closeDrawer}
          >
            <ListItemIcon className={classes.itemIcon}>{Icon && <Icon />}</ListItemIcon>
            <ListItemText secondary={title} secondaryTypographyProps={{ className: classes.itemText }} />
          </ListItem>
        ))}
      </List>
      <div className={classes.logo}>
        <Typography color='inherit' component='span' className={classes.logoText}>
          IPP
        </Typography>
      </div>
    </SwipeableDrawer>
  );
};
